<template>
  <div>
    <page-header
      icon="mdi-store"
      :title="$t('delivery_restaurants')"
      :subtitle="$t('select_delivery_restaurant')"
    />

    <div class="mt-3 px-2">
      <v-row
        v-if="loading.initialize"
        justify="center"
        align="center"
        style="min-height: 400px"
      >
        <v-col cols="auto">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
          cols="12"
          md="4"
          lg="3"
          v-for="restaurant in restaurants"
          :key="restaurant.id"
        >
          <v-card
            class="h-100 d-flex flex-column"
            :to="{
              name: 'restoran-dostava',
              params: { id: restaurant.id, name: restaurant.name },
            }"
          >
            <v-img
              height="180"
              :src="getRestaurantLogo(restaurant)"
              :alt="toLatin(restaurant.name)"
            >
              <template #placeholder>
                <div
                  class="d-flex align-center justify-center fill-height grey lighten-4"
                >
                  <v-icon size="36">mdi-storefront-outline</v-icon>
                </div>
              </template>
            </v-img>

            <v-card-title class="pb-1">
              {{ toLatin(restaurant.name) }}
            </v-card-title>

            <v-card-subtitle class="pt-0 pb-0">ID: {{ restaurant.id }}</v-card-subtitle>

            <v-card-text class="pt-3 flex-grow-1">
              <div class="info-block mb-3">
                <div class="info-label">
                  <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                  {{ $t("address") }}
                </div>
                <div class="info-value">{{ toLatin(restaurant.address || "-") }}</div>
              </div>

              <div class="info-grid mb-3">
                <div class="info-cell" v-if="restaurant.phone">
                  <div class="info-label">
                    <v-icon x-small class="mr-1">mdi-phone</v-icon>
                    {{ $t("phone") }}
                  </div>
                  <div class="info-value">{{ restaurant.phone }}</div>
                </div>

                <div class="info-cell" v-if="restaurant.email">
                  <div class="info-label">
                    <v-icon x-small class="mr-1">mdi-email</v-icon>
                    {{ $t("email") }}
                  </div>
                  <div class="info-value">{{ restaurant.email }}</div>
                </div>
              </div>

              <div class="info-block" v-if="getDeliveryRange(restaurant.settings)">
                <div class="info-label">
                  <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                  {{ $t("delivery_time") }}
                </div>
                <div class="info-value">{{ getDeliveryRange(restaurant.settings) }}</div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import conf from "@/config";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";
export default {
  mixins: [hasSnackbar],
  data: () => ({
    restaurants: [],
    loading: {
      initialize: false,
    },
  }),
  created() {
    this.initialize();
  },
  methods: {
    getRestaurantLogo(restaurant) {
      const logo = restaurant?.settings?.logo;
      if (!logo) return "";
      return `${conf.apiUrlBase}/gallery/${restaurant.id}/${logo}`;
    },
    formatTwoDigits(value) {
      if (value === null || value === undefined || value === "") return null;
      const normalized = String(value).trim();
      if (!/^\d{1,2}$/.test(normalized)) return null;
      return normalized.padStart(2, "0");
    },
    getDeliveryRange(settings) {
      const fromHour = this.formatTwoDigits(settings?.delivery_from_hour);
      const fromMin = this.formatTwoDigits(settings?.delivery_from_min);
      const toHour = this.formatTwoDigits(settings?.delivery_to_hour);
      const toMin = this.formatTwoDigits(settings?.delivery_to_min);

      if (!fromHour || !fromMin || !toHour || !toMin) return "";
      return `${fromHour}:${fromMin} - ${toHour}:${toMin}`;
    },
    async initialize() {
      if (this.loading.initialize) return;
      this.loading.initialize = true;

      try {
        const res = await restaurantService.getDeliveryRestaurants();
        this.restaurants = res.data;
      } catch (error) {
        console.error("Error loading delivery restaurants:", error);
        this.showErrorSnackbar(this.$t("error_loading_restaurants"));
      } finally {
        this.loading.initialize = false;
      }
    },
  },
};
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.info-cell {
  min-width: 0;
}

.info-block,
.info-cell {
  border: 1px solid #eceff1;
  border-radius: 8px;
  padding: 8px 10px;
  background: #fff;
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 4px;
}

.info-value {
  font-size: 13px;
  line-height: 1.35;
  word-break: break-word;
}
</style>
